import React from "react";
import CreatePositionModal from "@/appComponents/Blocks/Modals/RecordEditorModal/CreatePositionModal";
import { useTableManagerContext } from "@/providers/AppendTableProvider";
import { enumObjectTypes } from "@coreapp/constants";
import { useChartSettingsContext } from "@/providers/ChartSettingsProvider";

export const AppendTableCreatePositionModal = () => {
  const {
    recordEditorContextValue: {
      theData,
      showCreatePosition,
      onSaveRecordEdit,
      onClosePositionEditor
    },
    tableManager
  } = useTableManagerContext();
  const { chartConfigRef } = useChartSettingsContext();

  if (!showCreatePosition || !tableManager.state) return null;

  const positionData = theData[enumObjectTypes.position];
  const queryChartId = chartConfigRef.current?.ID || null;

  return (
    <CreatePositionModal
      theData={theData}
      showCreatePosition={showCreatePosition}
      showClonePosition={false}
      onSaveRecordEdit={onSaveRecordEdit}
      onClosePositionEditor={onClosePositionEditor}
      parentPosition={positionData?.baseObj}
      manager={tableManager.state}
      queryChartId={queryChartId}
    />
  );
};
